var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyChest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 128,
    viewBox: "0 0 240 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 32,
    rx: 8,
    fill: "#43474F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 22,
    height: 22,
    rx: 4,
    fill: "#8E939C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 7,
    width: 75,
    height: 8,
    rx: 2,
    fill: "#8E939C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 18,
    width: 55,
    height: 8,
    rx: 2,
    fill: "#646A73"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 12,
    width: 40,
    height: 8,
    rx: 2,
    fill: "#25292E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 12,
    width: 18,
    height: 8,
    rx: 2,
    fill: "#25292E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 12,
    width: 18,
    height: 8,
    rx: 2,
    fill: "#8E939C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    y: 48,
    width: 240,
    height: 32,
    rx: 8,
    fill: "#43474F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 53,
    width: 22,
    height: 22,
    rx: 4,
    fill: "#8E939C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 55,
    width: 75,
    height: 8,
    rx: 2,
    fill: "#8E939C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 66,
    width: 55,
    height: 8,
    rx: 2,
    fill: "#646A73"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 60,
    width: 40,
    height: 8,
    rx: 2,
    fill: "#25292E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 60,
    width: 18,
    height: 8,
    rx: 2,
    fill: "#25292E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 60,
    width: 18,
    height: 8,
    rx: 2,
    fill: "#8E939C"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    y: 96,
    width: 240,
    height: 32,
    rx: 8,
    fill: "#43474F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 101,
    width: 22,
    height: 22,
    rx: 4,
    fill: "#8E939C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 103,
    width: 75,
    height: 8,
    rx: 2,
    fill: "#8E939C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 114,
    width: 55,
    height: 8,
    rx: 2,
    fill: "#646A73"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 108,
    width: 40,
    height: 8,
    rx: 2,
    fill: "#25292E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 108,
    width: 18,
    height: 8,
    rx: 2,
    fill: "#25292E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 108,
    width: 18,
    height: 8,
    rx: 2,
    fill: "#8E939C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChest);
export default __webpack_public_path__ + "static/media/empty-chest.e9bccc8cd2e525803490f25867b1137d.svg";
export { ForwardRef as ReactComponent };